export const getInitials = (str) => {
    const results = [];
    const wordArray = str.split(' ');
    wordArray.forEach((e) => {
        results.push(e[0]);
    });
    return results.join('').toUpperCase();
};

export const dataToApiFormat = (data) => {
    const result = {};

    for (const [key, value] of Object.entries(data)) {
        if (value !== null && value !== undefined && value !== '') {
            const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            result[snakeCaseKey] = value;
        }
    }

    return result;
};


export const isNewCandidate = (candidate) => {
    const createdAt = new Date(candidate.created_at);
    const now = new Date();
    const diffTime = Math.abs(now - createdAt);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 2 ? true : false; // two days
}

/**
* Extract the first matching interest_code value by consultant(client.id)
* @param {Array} interests - List of interest objects
* @param {number} userId - Current user ID
* @returns {string|null} - First matching interest_code or null
*/
export const getFirstInterestCode = (interests, userId) => {
    const match = interests
        .filter(
            (interest) =>
                interest.interest_code && // Ensure interest_code is not null or empty
                !interest.is_favorite && // Ensure is_favorite is false
                interest.client.id === userId // Ensure client.id matches current user
        )
        .sort((a, b) => b.id - a.id)[0]; // Get the first match by descending ID

    return match ? match.interest_code : null;
};

/**
* Extract the first matching is_favorite value
* @param {Array} interests - List of interest objects
* @param {number} userId - Current user ID
* @returns {boolean|null} - First matching is_favorite or null
*/
export const getFirstIsFavorite = (interests, userId) => {
    const match = interests
        .filter(
            (interest) =>
                interest.is_favorite  // Ensure is_favorite is true
        )
        .sort((a, b) => b.id - a.id)[0]; // Get the first match by descending ID

    return match ? match.is_favorite : null;
};


export const sortFilesByType = (files, keyOrder) => {
    // Create a map of the keyOrder for quick lookup
    const keyOrderMap = keyOrder.reduce((acc, key, index) => {
        acc[key] = index;
        return acc;
    }, {});

    // Filter out items with type "PDF"
    const filteredFiles = files.filter((file) => file.type !== "PDF");

    // Sort the files based on the keyOrder
    return filteredFiles.sort((a, b) => {
        const indexA = keyOrderMap[a.type] !== undefined ? keyOrderMap[a.type] : Infinity;
        const indexB = keyOrderMap[b.type] !== undefined ? keyOrderMap[b.type] : Infinity;

        return indexA - indexB;
    });
};

export const extractUrlJobDetails = (pathname) => {
    // Regular expression to match the S10 pattern (S followed by two digits)
    const sourceRegex = /(S\d{2})/;
    // Regular expression to match the slug in the format {title}-{id}
    const slugRegex = /([a-zA-Z0-9_-]+-\d+)(?=\/S\d{2})/;
    // Regular expression to match the id (numeric part)
    const idRegex = /(\d+)(?=\/S\d{2})/;

    // Extract the source (S92, S93, etc.)
    const sourceMatch = pathname.match(sourceRegex);
    const source = sourceMatch ? sourceMatch[0] : null;

    // Extract the slug (if it exists in the format {title}-{id})
    const slugMatch = pathname.match(slugRegex);
    let slug = slugMatch ? slugMatch[0] : null;

    // Extract the id (numeric part)
    const idMatch = pathname.match(idRegex);
    const id = idMatch ? idMatch[1] : null;

    // If the slug is not in the format {title}-{id}, set it to null
    if (slug && !slug.includes('-')) {
        slug = null;
    }

    return {
        id: id ? parseInt(id, 10) : null, // Convert id to a number
        slug: slug, // Return the slug in the format {title}-{id} or null
        source: source,
    };
};

// For Page applications: retrieve templates by theme
export const matchTheme = (value) => {
    switch (value) {
        case 1:
            return 'REJECT';
        case 2:
            return 'ACCEPT';
        case 3:
            return 'PENDING';
        case 6:
            return 'MISSION';
        default:
            return 'NC';
    }
}
